import { createSelector } from 'reselect'
import { State } from 'index'

const userSelector = (state: State) => state.user

export const getUsers = createSelector([userSelector], (state) => state.users)
